const addPrefix = require('./addPrefix');
export default function classNames(...cssClasses) {
	const isObject = (variable) => Object.prototype.toString.call(variable) === '[object Object]';
	let className = '';
	return cssClasses
		.map((cssClass) => {
			if (!cssClass) return '';
			if (isObject(cssClass)) {
				return Object.entries(cssClass)
					.map(([value, condition]) => {
						return !!condition ? addPrefix(value) : '';
					})
					.filter((c) => !!c)
					.join(' ');
			}
			return addPrefix(cssClass);
		})
		.join(' ');
}
